import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonFooter,
  IonItem,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import onboardPLNPlus from "../../../assets/img/icons/onboard_plnplus.svg";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircle,
  checkmarkCircleOutline,
  chevronForward,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  pencil,
  pencilSharp,
  pricetag,
  pricetags,
  settings,
  share,
  shareOutline,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _ from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import LinkUtils from "../../../lib/LinkUtils";
import OneSignal from "onesignal-cordova-plugin";
import { PushNotifications } from "@capacitor/push-notifications";
import onboardNotifications from "../../../assets/img/icons/onboard_notifications.svg";

const NotificationsPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
  next: () => void;
  previous: () => void;
  hasNext: boolean;
  hasPrevious: boolean;
  step: any;
}> = ({
  nativeMode = false,
  showBackButton = false,
  next,
  previous,
  hasNext,
  hasPrevious,
  step,
}) => {
  const history = useHistory();
  const [loading, setLoading] = useState(
    Capacitor?.isNativePlatform() ? true : false,
  );
  const pageRef = useRef();

  const [user, setUser] = useState<any>(null);

  useIonViewDidEnter(() => {
    PubSub.publish("mobileScreenChange");

    StorageUtils.get("user_customer").then((user) => {
      setUser(user);
    });
  }, []);

  return (
    <IonPage ref={pageRef}>
      {nativeMode ? (
        <>
          <IonHeader>
            <IonToolbar className="pln-native-toolbar">
              {hasPrevious ? (
                <IonButtons slot="start">
                  <IonBackButton></IonBackButton>
                </IonButtons>
              ) : null}
              <IonTitle>Notifications</IonTitle>
            </IonToolbar>
          </IonHeader>
        </>
      ) : (
        <Navbar
          showBackButton={hasPrevious}
          actionButton={<></>}
          showMenuButton={false}
          pageName={"Notifications"}
          onGoBack={() => {
            history.goBack();
          }}
        ></Navbar>
      )}

      <IonContent className="bg-white">
        <div className="ion-padding">
          <div
            className="text-center flex h-full items-center"
            style={{
              height: "calc(100vh - 350px)",
            }}
          >
            <div className="mx-auto">
              <div className="rounded w-full min-h-[300px] max-h-[300px] sm:max-h-[350px] mt-[1rem] mb-[1.5rem] flex justify-center">
                <img
                  src={onboardNotifications}
                  alt="PLN+"
                  className="w-auto h-full mx-auto max-h-[300px] sm:max-h-[350px] object-contain"
                />
              </div>

              <h2 className="font-medium font-[SourceSerif] text-2xl mb-[0.5rem]">
                Stay In The Loop!
              </h2>

              <p className="" style={{ fontSize: 18 }}>
                Turn on push notifications to receive important account updates,
                tips, and motivation. 📲💪
              </p>
            </div>
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar className="pln-native-toolbar-footer">
          <IonButton
            onClick={() => {
              if (Capacitor.isNativePlatform()) {
                OneSignal.Notifications.requestPermission().then(
                  async (accepted: boolean) => {
                    console.log("User accepted notifications: " + accepted);

                    await StorageUtils.set("push_permission_prompted", true);

                    next();
                  },
                );
              } else {
                next();
              }
            }}
            expand="block"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            Enable Notifications
          </IonButton>
          <IonButton
            onClick={async () => {
              await StorageUtils.set("push_permission_prompted", true);

              next();
            }}
            expand="block"
            color="dark"
            fill="clear"
            mode={
              Capacitor.isNativePlatform()
                ? Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
                : "ios"
            }
          >
            Maybe Later
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  );
};

export default NotificationsPage;
